export default function SkillsSnapshot(){
    return (
        <section className="skills-snapshot">
            <h2>Skills snapshot</h2>
            <div className="skills-snapshot-content">
                <h3>Languages and Framework</h3>
                <div className="skills-list">
                    <span className="badge">JavaScript</span>
                    <span className="badge">TypeScript</span>
                    <span className="badge">Java</span>
                    <span className="badge">React</span>
                    <span className="badge">React Router</span>
                    <span className="badge">Redux/Context API</span>
                    <span className="badge">HTML5</span>
                    <span className="badge">CSS</span>
                    <span className="badge">NodeJs</span>
                </div>
            </div>
            <div className="skills-snapshot-content">
                <h3>Core FrontEnd Skills</h3>
                <div className="skills-list">
                    <span className="badge">Web APIs</span>
                    <span className="badge">Accessibility (a11y)</span>
                    <span className="badge">Responsive Design</span>
                    <span className="badge">System Design (Beginner)</span>
                </div>
            </div>
            <div className="skills-snapshot-content">
                <h3>Certifications</h3>
                <div className="skills-list">
                    <a className="badge" href="https://www.credly.com/badges/9370c637-5117-45b0-b299-7cfd434e514f" target="_blank" rel="noopener noreferrer">
                    AWS Certified Cloud Practitioner 🔗
                    </a>
                    <a className="badge" href="https://www.udacity.com/certificate/7F2GVM25" target="_blank" rel="noopener noreferrer">
                    FrontEnd Developer Nanodegree 🔗
                    </a>
                    <a className="badge" href="https://v1.scrimba.com/certificate/uvYn9vCw/greact" target="_blank" rel="noopener noreferrer">
                    The React Bootcamp 🔗
                    </a>
                    <a className="badge" href="https://ninjasfiles.s3.amazonaws.com/certificate13677709cdf169d9a63aa025194ec7014284a3a.pdf" target="_blank" rel="noopener noreferrer">
                    Career Camp | Front End | Full Stack Web Development 🔗
                    </a>
                </div>
            </div>
        </section>
    )
}